import ForgotPassword from './ForgotPassword';
export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/index.js